export const tailwindConfig = {
  fontFamily: {
    sans: ['Rubik', 'sans-serif'],
    montserrat: ['Montserrat', 'sans-serif'],
  },
  extend: {
    colors: {
      navyPrime: '#002953',
      primeval: {
        50: '#fef1f9',
        100: '#ffe4f5',
        200: '#ffcaee',
        300: '#ff9ede',
        400: '#ff62c5',
        500: '#ff34ab',
        600: '#e00d7e',
        700: '#d2046d',
        800: '#ae0659',
        900: '#900b4c',
        950: '#59002a',
      },
      secondary: {
        50: '#fef1f9',
        100: '#ffe4f5',
        200: '#ffcaee',
        300: '#ff9ede',
        400: '#ff62c5',
        500: '#ff34ab',
        600: '#e00d7e',
        700: '#d2046d',
        800: '#ae0659',
        900: '#900b4c',
        950: '#59002a',
      },
      shade: {
        50: '#fef1f9',
        100: '#ffe4f5',
        200: '#ffcaee',
        300: '#ff9ede',
        400: '#ff62c5',
        500: '#ff34ab',
        600: '#e00d7e',
        700: '#d2046d',
        800: '#ae0659',
        900: '#900b4c',
        950: '#59002a',
      },
      success: {
        50: '#f0fdf4',
        100: '#dcfce6',
        200: '#bbf7cf',
        300: '#85f0aa',
        400: '#49df7d',
        500: '#23d160',
        600: '#15a447',
        700: '#14813b',
        800: '#166533',
        900: '#14532c',
        950: '#052e15',
      },
      info: {
        50: '#f0f8ff',
        100: '#e0effe',
        200: '#bbe0fc',
        300: '#7fc7fa',
        400: '#3bacf5',
        500: '#209cee',
        600: '#0572c4',
        700: '#065b9e',
        800: '#094d83',
        900: '#0e426c',
        950: '#092948',
      },
      warning: {
        50: '#fefbe8',
        100: '#fff7c2',
        200: '#ffec89',
        300: '#ffdd57',
        400: '#fdc412',
        500: '#ecaa06',
        600: '#cc8202',
        700: '#a35b05',
        800: '#86480d',
        900: '#723b11',
        950: '#431d05',
      },
      danger: {
        50: '#ffefef',
        100: '#ffdcdc',
        200: '#ffbfbf',
        300: '#ff9292',
        400: '#ff5454',
        500: '#ff1f1f',
        600: '#ff0000',
        700: '#db0000',
        800: '#b40000',
        900: '#940808',
        950: '#520000',
      },
    },
    height: {
      26: '6.5rem',
      30: '120px',
    },
    width: {
      26: '6.5rem',
    },
    minHeight: {
      18: '4.5rem',
    },
    borderWidth: {
      '1.5': '1.5px',
    },
    fontSize: {
      '2xs': ['0.625rem', '0.75rem'],
    },
  },
};